import { useState } from 'react';
import type { TyreMoveKind } from '../policies/tyre-move.policy';

/** Which dialog a tyre's page has open: a move's modal or the edit drawer. Opening one clears the last refusal so it doesn't greet the next try. */
export function useTyreDialogs(resetMoveError: () => void, resetSaveError: () => void) {
  const [kind, setKind] = useState<TyreMoveKind | null>(null);
  const [isEditing, setIsEditing] = useState(false);

  return {
    kind,
    isEditing,
    openMove: (next: TyreMoveKind) => {
      resetMoveError();
      setKind(next);
    },
    openEdit: () => {
      resetSaveError();
      setIsEditing(true);
    },
    closeMove: () => setKind(null),
    closeEdit: () => setIsEditing(false),
  };
}
